import React, { useContext } from 'react'
import styled from 'styled-components'
import Modal, { PrevButton } from '@jarvis.oddle/core/components/Modal'
import { Text } from '@jarvis.oddle/core/components/Typo'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import modalController, {
  makeControlledModal
} from 'src/decorators/ModalController'
import { paddingSizes } from '@jarvis.oddle/core/theme/default'
import breakpoint from 'src/utils/styledComponentsBreakpoint'
import IconClose from '@jarvis.oddle/core/components/Icons/IconClose'
import Flex from '@jarvis.oddle/core/components/Flex'
import Div from '@jarvis.oddle/core/components/Div'
import IconSmileChat from 'src/components/icons/IconSmileChat'
import Button from '@jarvis.oddle/core/components/Button'
import IconOddleLogistic from 'src/components/icons/IconOddleLogistic'

const Container = styled(Modal.FlexContainer).attrs(() => ({
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  padding: paddingSizes.medium
}))`
  position: relative;
  background: ${(props) => props.theme.colorContainerColor};
  width: 95%;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
  left: 50%;
  height: fit-content;
  ${breakpoint('desktop')`
    width: 100%;
    max-width: 600px;
    height: fit-content;
  `}
`

const CloseButtonContainer = styled(Flex).attrs(() => ({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  role: 'button'
}))`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 10;
`

const StyledPrevButton = styled(PrevButton)`
  position: absolute;
  top: 30px;
  right: 10px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 10;
`

const StyledIconChat = styled(Div)`
  margin-top: 40px;
  margin-bottom: 20px;
`
const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
`

const StyledTextButton = styled(Text)`
  font-size: 18px;
  color: ${(props) => props.theme.buttonTextColor};
  font-weight: 700;
`

const StyledOddleLogistic = styled(Div)`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

interface ContactRestaurantModalProps {
  modal: {
    show: boolean
    onClose: (x: () => void) => void
  }
  id: string
  helpOption: string
  emailStore: string
  phoneStore: string
  addressStore: string
  isPickup: boolean
  deliveryFulfilmentParty: {
    deliveryParty?: string
    partnerDisplayName?: string
  }
}

const ContactLogisticModal = ({
  modal,
  id,
  helpOption,
  phoneStore,
  emailStore,
  addressStore,
  isPickup,
  deliveryFulfilmentParty
}: ContactRestaurantModalProps): JSX.Element => {
  const { t } = useContext(TranslationContext)
  const directToChat = () => {
    window.open(
      `https://eats.oddle.me/help/contact?redirectFromThankyouPage=${true}&orderId=${id}&helpOption=${helpOption}`
    )
  }
  return (
    <Modal {...modal} show={modal.show} slideInAnimation='right'>
      <Container>
        <CloseButtonContainer
          onClick={modal.onClose}
          data-testid='button.close'
        >
          <IconClose width={14} height={14} />
        </CloseButtonContainer>
        <Flex
          justifyContent='center'
          flexDirection='column'
          alignItems='center'
        >
          <StyledPrevButton
            onClick={() =>
              modal.onClose(() =>
                modalController.showModal('NeedHelpModal', {
                  isPickup,
                  phoneStore,
                  emailStore,
                  addressStore,
                  id,
                  deliveryFulfilmentParty
                })
              )
            }
          >
            <PrevButton data-testid='backButton' />
          </StyledPrevButton>
          <StyledIconChat>
            <IconSmileChat width={56} height={46} />
          </StyledIconChat>
          <Text textAlign='center'>
            {t(
              'The Oddle Logistics team manage this delivery and is able to serve you better'
            )}
          </Text>
          <StyledButton
            onClick={directToChat}
            data-testid='chatOddleLogisticsButton'
          >
            <StyledTextButton>
              {t('Chat with Oddle Logistics')}
            </StyledTextButton>
          </StyledButton>
          <Text textAlign='center'>
            {t(
              'Chat hours: 10am - 10pm daily. Oddle pass login may be required'
            )}
          </Text>
          <StyledOddleLogistic>
            <IconOddleLogistic width={86} height={13} />
          </StyledOddleLogistic>
        </Flex>
      </Container>
    </Modal>
  )
}

export default makeControlledModal(ContactLogisticModal, 'ContactLogisticModal')
